module.exports = __webpack_public_path__ + "static/media/innova.49ba0d31.png";